module.exports = __webpack_public_path__ + "img/logo-up-33.caa12592.png";